import { httpClient } from '@/domains/core/httpClient/httpClient';
import { getAppSetting } from '@/domains/core/settings/appSettings';

export const getSmartDescription = async (modelId: number) => {
  const { data } = await httpClient.get(
    `${getAppSetting('MS_API_URL')}/api/v1/smart-description/${modelId}`,
  );
  return data.description;
};
